module.exports = __webpack_public_path__ + "img/medalha-bem-vindo.07f356d6.jpg";